import isString from 'lodash/isString';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {Collapse} from 'react-collapse';
import IconChevronDown from '@spothero/icons/chevron-down';
import IconChevronUp from '@spothero/icons/chevron-up';
import WithCollapsibleCard from './WithCollapsibleCard';

class Card extends Component {
    static propTypes = {
        id: PropTypes.string,
        className: PropTypes.string,
        title: PropTypes.node,
        heading: PropTypes.string,
        isOpen: PropTypes.bool,
        collapsible: PropTypes.bool,
        children: PropTypes.node.isRequired,
        heightReady: PropTypes.bool,
        noPadding: PropTypes.bool,
        onMeasure: PropTypes.func.isRequired,
        onToggle: PropTypes.func.isRequired,
        'data-testid': PropTypes.string,
    };

    constructor(props) {
        super(props);

        const {title, heading, collapsible} = props;

        if (collapsible && (heading || !title)) {
            throw new Error(
                'Collapsible Cards cannot have a heading and should contain a title.'
            );
        }
    }

    _renderContent() {
        const {children, title, heading, collapsible, heightReady} = this.props;
        const contentClasses = classNames(
            'Card-content',
            {'Card-content-with-title': title},
            {'Card-content-hidden': collapsible && !heightReady}
        );

        return (
            <>
                {heading && <h2 className="Card-heading">{heading}</h2>}
                <div className={contentClasses}>{children}</div>
            </>
        );
    }

    render() {
        const {
            id,
            className,
            title,
            collapsible,
            noPadding,
            isOpen,
            onMeasure,
            onToggle,
            'data-testid': testId,
        } = this.props;
        const classes = classNames(
            'Card',
            {'Card-open': isOpen},
            {'Card-no-padding': noPadding},
            className
        );

        return (
            <div data-testid={testId} id={id} className={classes}>
                {title && (
                    <div className="Card-title">
                        {isString(title) ? <h3>{title}</h3> : title}
                        {collapsible && (
                            <span className="Card-toggle" onClick={onToggle}>
                                {isOpen ? (
                                    <IconChevronUp />
                                ) : (
                                    <IconChevronDown />
                                )}
                            </span>
                        )}
                    </div>
                )}
                {collapsible ? (
                    <Collapse
                        isOpened={isOpen}
                        onMeasure={onMeasure}
                        springConfig={{stiffness: 300, damping: 25}}
                    >
                        {this._renderContent()}
                    </Collapse>
                ) : (
                    this._renderContent()
                )}
            </div>
        );
    }
}

export default WithCollapsibleCard(Card);
